import { useCallback } from "react";
import useDispatchToast from "./useDispatchToast";
import { Toast } from "../../context/toast-context";

export default useDispatchDangerToast;

type DispatchDangerToast = (toast: Omit<Toast, "variant">) => void;
const variant = "danger";
function useDispatchDangerToast(): DispatchDangerToast {
  const dispatchToast = useDispatchToast();
  return useCallback(
    (toast) => {
      dispatchToast({
        variant,
        ...toast,
      });
    },
    [dispatchToast],
  );
}
